import { View } from "react-native";

type SpaceProps = {
  width?: number;
  height?: number;
};

export const Space: React.FC<SpaceProps> = ({ width = 1, height = 1 }) => (
  <View style={{ width, height, flexShrink: 0 }} />
);

type FillProps = {
  minWidth?: number;
  minHeight?: number;
};

export const Fill: React.FC<FillProps> = ({ minWidth = 1, minHeight = 1 }) => (
  <View
    style={{
      minWidth: minWidth,
      minHeight: minHeight,
      flex: 1,
    }}
  />
);
